import React, { useState, useEffect, createRef, Fragment } from 'react';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles, createStyles, SvgIcon, useTheme, Toolbar, Typography, TextField, CircularProgress, Link } from '@material-ui/core';
import classnames from 'classnames';
import MenuIcon from '@material-ui/icons/Menu';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles as makeStyles$1, createStyles as createStyles$1, useTheme as useTheme$1 } from '@material-ui/core/styles';
import classnames$1 from 'classnames/bind';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Chip from '@material-ui/core/Chip';
import { Motion, spring } from 'react-motion';
import Countdown from 'react-countdown';
import { Autocomplete } from '@material-ui/lab';
import { useDebounce } from 'use-debounce';
import SearchIcon from '@material-ui/icons/Search';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var useStyles$g = makeStyles(function (theme) {
    return createStyles({
        appBar: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            left: 0,
            top: "-2px",
            height: 45,
            boxShadow: "none",
            position: "sticky",
            padding: "0px 5vw"
        },
        toolbar: {
            minHeight: 50,
            display: "flex",
            padding: 0
        },
        text: {
            fontSize: "20px",
            paddingLeft: theme.spacing(4.5),
            textAlign: "start",
            fontFamily: theme.typography.h3.fontFamily
        },
        arrowIcon: {
            paddingRight: theme.spacing(2)
        },
        logo: {
            height: 35
        },
        logoButton: {
            border: "none",
            padding: "0px",
            background: "none"
        },
        headerText: {
            flex: 1
        }
    });
});

var Svg = function (props) {
    var _a = props.svgStyleProps, className = _a.className, viewBox = _a.viewBox, width = _a.width, height = _a.height, primaryClassName = _a.primaryClassName, groupClass = _a.groupClass, style = _a.style, stroke = _a.stroke, strokeWidth = _a.strokeWidth;
    var isSvg = props.isSvg, icon = props.icon, path = props.path, fill = props.fill, transform = props.transform, onIconClick = props.onIconClick, ariaLabel = props.ariaLabel;
    var renderSvg = function () {
        return (React.createElement("svg", { width: width, height: height, viewBox: viewBox, className: "svg-icon " + (className || ""), focusable: true, "aria-hidden": false, style: style, onClick: onIconClick, "aria-label": ariaLabel },
            React.createElement("g", { className: groupClass, transform: transform ? transform : "", stroke: stroke ? stroke : "none", strokeWidth: strokeWidth ? strokeWidth : "1px" }, path instanceof Array ? (path.map(function (p) { return (React.createElement("path", { stroke: p.stroke ? p.stroke : "none", strokeWidth: p.strokeWidth ? p.strokeWidth : "1px", fill: p.fill ? p.fill : fill, d: p.path, className: primaryClassName })); })) : (React.createElement("path", { fill: fill, d: path, className: primaryClassName })))));
    };
    var renderIcon = function () {
        return React.createElement(SvgIcon, null, icon);
    };
    return isSvg ? renderSvg() : renderIcon();
};

var Header = function (props) {
    var _a, _b, _c, _d;
    var classes = useStyles$g();
    var theme = useTheme();
    var _e = props.variant, variant = _e === void 0 ? "default" : _e, clientLogoPrimary = props.clientLogoPrimary, clientLogoSecondary = props.clientLogoSecondary, svgProps = props.svgProps, isHeaderInverted = props.isHeaderInverted, headerText = props.headerText, headerStyle = props.headerStyle, className = props.className, onSvgSelection = props.onSvgSelection, _f = props.isScrollHeader, isScrollHeader = _f === void 0 ? true : _f, onLogoSelection = props.onLogoSelection, onBackSelection = props.onBackSelection, onMenuSelection = props.onMenuSelection, _g = props.menuState, menuState = _g === void 0 ? "none" : _g, hideBackButton = props.hideBackButton, _h = props.primaryLogoTabIndex, primaryLogoTabIndex = _h === void 0 ? 0 : _h, _j = props.secondaryLogoTabIndex, secondaryLogoTabIndex = _j === void 0 ? 0 : _j;
    var transparentHeaderTheme = {
        headerBackground: "transparent",
        logo: isHeaderInverted ? clientLogoPrimary : clientLogoSecondary,
        text: isHeaderInverted
            ? theme.palette.primary.contrastText
            : theme.palette.secondary.contrastText,
        borderBottom: "0",
        transition: "background-color 150ms ease-out 0s, border-bottom 150ms ease-out 0s"
    };
    var nontransparentHeaderTheme = {
        headerBackground: theme.palette.primary.contrastText,
        logo: clientLogoSecondary,
        text: "",
        borderBottom: "0",
        transition: "background-color 150ms ease-out 0s, border-bottom 150ms ease-out 0s"
    };
    var _k = useState(nontransparentHeaderTheme), headerTheme = _k[0], setHeaderTheme = _k[1];
    useEffect(function () {
        var scrollElem = document.getElementById("main-container");
        scrollElem && scrollElem.addEventListener("scroll", onScroll);
    }, []);
    var onScroll = function (elem) {
        var _a;
        if (isScrollHeader) {
            var headerTheme_1 = elem && ((_a = elem === null || elem === void 0 ? void 0 : elem.target) === null || _a === void 0 ? void 0 : _a.scrollTop) > 25
                ? __assign(__assign({}, transparentHeaderTheme), { headerBackground: theme.palette.primary.contrastText, logo: clientLogoSecondary, text: theme.palette.secondary.contrastText, borderBottom: "1px solid rgb(208, 208, 208)" }) : transparentHeaderTheme;
            setHeaderTheme(headerTheme_1);
        }
    };
    return (React.createElement(AppBar, { className: classnames(classes.appBar, "" + className), style: {
            backgroundColor: headerTheme.headerBackground,
            borderBottom: headerTheme.borderBottom,
            transition: headerTheme.transition
        } },
        React.createElement(Toolbar, { className: classes.toolbar }, variant === "hamburger-menu" ? (React.createElement("div", { style: {
                display: "flex",
                width: "100%",
                height: "22pt",
                justifyContent: "center",
                alignItems: "center"
            } },
            React.createElement(ArrowBackIosIcon, { style: {
                    height: "0.8rem",
                    fontWeight: "bold",
                    color: headerTheme.text,
                    visibility: hideBackButton ? "hidden" : "visible"
                }, onClick: onBackSelection }),
            React.createElement("div", { style: {
                    flex: 1,
                    textAlign: "center",
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                } }, headerText ? (React.createElement("span", { style: headerStyle
                    ? headerStyle
                    : {
                        color: headerTheme.text
                    } }, headerText)) : (headerTheme === null || headerTheme === void 0 ? void 0 : headerTheme.logo) ? (React.createElement("img", { src: headerTheme.logo.url, style: headerStyle ? headerStyle : { maxHeight: 40 }, alt: (_a = headerTheme === null || headerTheme === void 0 ? void 0 : headerTheme.logo) === null || _a === void 0 ? void 0 : _a.altText, "aria-label": (_b = headerTheme === null || headerTheme === void 0 ? void 0 : headerTheme.logo) === null || _b === void 0 ? void 0 : _b.altText })) : ("")),
            menuState === "menu" ? (React.createElement(MenuIcon, { style: {
                    width: 24,
                    height: "100%",
                    color: "#1651A8",
                    fontWeight: "bold"
                }, onClick: onMenuSelection })) : menuState === "close" ? (React.createElement(CloseIcon, { style: {
                    height: "100%",
                    color: headerTheme.headerBackground === "transparent"
                        ? "white"
                        : headerTheme.text
                }, onClick: onMenuSelection })) : (""))) : (React.createElement(React.Fragment, null,
            React.createElement("button", { className: classes.logoButton, tabIndex: primaryLogoTabIndex, onClick: onSvgSelection, "aria-label": "Navigate back" },
                React.createElement(Svg, { svgStyleProps: (svgProps === null || svgProps === void 0 ? void 0 : svgProps.svgStyleProps) || {}, fill: (svgProps === null || svgProps === void 0 ? void 0 : svgProps.fill) || theme.palette.primary.main || "", transform: (svgProps === null || svgProps === void 0 ? void 0 : svgProps.transform) || "", path: (svgProps === null || svgProps === void 0 ? void 0 : svgProps.path) || "", isSvg: (svgProps === null || svgProps === void 0 ? void 0 : svgProps.isSvg) || false, ariaLabel: svgProps === null || svgProps === void 0 ? void 0 : svgProps.ariaLabel })),
            React.createElement("div", { className: classes.headerText }, headerText && headerText.length && (React.createElement("span", { className: classes.text, style: { color: headerTheme.text } }, headerText))),
            headerTheme.logo ? (React.createElement("button", { tabIndex: secondaryLogoTabIndex, className: classes.logoButton, onClick: onLogoSelection, "aria-label": "Navigate to Home" },
                React.createElement("img", { src: headerTheme.logo.url, className: classes.logo, alt: (_c = headerTheme === null || headerTheme === void 0 ? void 0 : headerTheme.logo) === null || _c === void 0 ? void 0 : _c.altText, "aria-label": (_d = headerTheme === null || headerTheme === void 0 ? void 0 : headerTheme.logo) === null || _d === void 0 ? void 0 : _d.altText }))) : null)))));
};

var useStyles$f = makeStyles$1(function (theme) {
    return createStyles$1({
        mainContainer: {
            width: "100%",
            height: "100%",
            marginTop: theme.spacing(13.5)
        },
        active_interest: {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText
        },
        inactive_interest: {
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.contrastText
        },
        circle: {
            display: "flex",
            justifyContent: "center",
            borderRadius: "50%",
            boxShadow: theme.palette.primary.light + " 0px 5px 14px -1px",
            fontWeight: "bold",
            cursor: "pointer",
            width: theme.spacing(10),
            height: theme.spacing(10),
            padding: theme.spacing(0.5)
        },
        interest_circle: {
            display: "flex",
            justifyContent: "center",
            borderRadius: "50%",
            boxShadow: "rgba(0,0,0,0.1) 0px 0px 20px 0px",
            fontWeight: "bold",
            cursor: "pointer",
            marginTop: "10px",
            width: theme.spacing(10),
            height: theme.spacing(10),
            padding: theme.spacing(0.5)
        },
        active_interest_circle: {
            display: "flex",
            justifyContent: "center",
            borderRadius: "50%",
            boxShadow: "none",
            fontWeight: "bold",
            cursor: "pointer",
            marginTop: "10px",
            width: theme.spacing(10),
            height: theme.spacing(10),
            padding: theme.spacing(0.5)
        },
        content: {
            alignSelf: "center",
            fontSize: theme.typography.subtitle2.fontSize,
            textAlign: "center",
            wordBreak: "break-word"
        },
        interest_name: {
            fontSize: "11px",
            textAlign: "center",
            wordBreak: "break-word",
            width: theme.spacing(20),
            height: theme.spacing(8)
        },
        content_icon_wrapper: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
        },
        interest_icon: {
            height: "40px",
            width: "40px",
            margin: "0px auto",
            paddingBottom: "10px"
        },
        defaultButton: {
            border: "none",
            background: "none",
            padding: "0px",
            color: "inherit"
        }
    });
});

var NumericConstants = {
    DEFAULT_CIRCLE_RADIUS: 35,
    MIN_LEFT_PADDING: 17,
    ERROR_FOR_CENTER: 10,
    MINIMUM_REQUIRED_DISTANCE: 40,
    ZERO: 0
};

var Interest = function (props) {
    var interests = props.interests, selectedInterests = props.selectedInterests, circleRadius = props.circleRadius, onReset = props.onReset, className = props.className, options = props.options, icons = props.icons;
    var _a = __assign(__assign({}, NumericConstants), options), MIN_LEFT_PADDING = _a.MIN_LEFT_PADDING, ERROR_FOR_CENTER = _a.ERROR_FOR_CENTER, DEFAULT_CIRCLE_RADIUS = _a.DEFAULT_CIRCLE_RADIUS, MINIMUM_REQUIRED_DISTANCE = _a.MINIMUM_REQUIRED_DISTANCE, ZERO = _a.ZERO;
    var classes = useStyles$f();
    var _b = useState([]), userInterests = _b[0], setInterests = _b[1];
    var textInput = createRef();
    var _c = React.useState(0); _c[0]; var setTime = _c[1];
    useEffect(function () {
        textInput = textInput.current;
        renderInterest();
    }, []);
    useEffect(function () {
        var timer = window.setInterval(function () {
            setTime(function (prevTime) { return prevTime + 1; });
        }, 1000);
        return function () {
            window.clearInterval(timer);
        };
    }, []);
    useEffect(function () {
        if (onReset) {
            selectedInterests([]);
            var updatedInterests = (userInterests || []).map(function (data) {
                var interest = Object.assign({}, data);
                interest.isSelected = false;
                return interest;
            });
            setInterests(updatedInterests);
        }
    }, [onReset]);
    var generateRandom = function (max) {
        return Math.floor(Math.random() * Math.floor(max));
    };
    var onInterestSelection = function (id) {
        var updatedInterests = (userInterests || []).map(function (data) {
            var interest = Object.assign({}, data);
            if (interest.id === id) {
                interest.isSelected = !interest.isSelected;
            }
            return interest;
        });
        var userSelectedInterests = (updatedInterests || []).filter(function (circle) { return circle.isSelected === true; });
        setInterests(updatedInterests);
        selectedInterests(userSelectedInterests);
    };
    var getInterestsWithIcon = function (interest) {
        var interestIcon = (icons || []).filter(function (item) { return interest.name === item.name; });
        if (interestIcon.length) {
            return (React.createElement("div", { className: classes.content_icon_wrapper },
                interest.isSelected ? (React.createElement("img", { className: classes.interest_icon, alt: "interest_icon", src: interestIcon[0].whiteIcon })) : (React.createElement("img", { className: classes.interest_icon, alt: "interest_icon", src: interestIcon[0].icon })),
                React.createElement("span", { className: classes.interest_name }, interest.name)));
        }
    };
    var generateCircle = function (data) {
        var interestClassName;
        if (icons === null || icons === void 0 ? void 0 : icons.length) {
            if (data.isSelected) {
                interestClassName = classnames$1(classes.active_interest_circle, classes.active_interest);
            }
            else {
                interestClassName = classnames$1(classes.interest_circle, classes.inactive_interest);
            }
        }
        else {
            if (data.isSelected) {
                interestClassName = classnames$1(classes.circle, classes.active_interest);
            }
            else {
                interestClassName = classnames$1(classes.circle, classes.inactive_interest);
            }
        }
        return (React.createElement("button", { onClick: function (event) {
                onInterestSelection(data.id);
            }, "aria-label": data.name, className: classes.defaultButton, tabIndex: 0 },
            React.createElement("div", { className: interestClassName, key: data.id, style: {
                    width: data.radius * 2,
                    height: data.radius * 2,
                    left: data.left,
                    top: data.top,
                    position: "absolute",
                    WebkitTapHighlightColor: "transparent"
                } }, icons && icons.length ? (getInterestsWithIcon(data)) : (React.createElement("span", { className: classes.content }, data.name)))));
    };
    var shuffleArray = function (array) {
        var m = array.length, t, i;
        while (m) {
            i = Math.floor(Math.random() * m--);
            t = array[m];
            array[m] = array[i];
            array[i] = t;
        }
        return array;
    };
    var plotCentersOfCircles = function (radius) {
        var minDistanceBetweenTwoCircleCenters = radius * 2 + MIN_LEFT_PADDING;
        var maximumCirclesPerColumn = Math.ceil(textInput.clientHeight /
            (radius + minDistanceBetweenTwoCircleCenters - MIN_LEFT_PADDING));
        var isMinimumFloatingAvailable = textInput.clientHeight % (radius + minDistanceBetweenTwoCircleCenters) >=
            MINIMUM_REQUIRED_DISTANCE
            ? true
            : false;
        maximumCirclesPerColumn = isMinimumFloatingAvailable
            ? maximumCirclesPerColumn
            : maximumCirclesPerColumn - 1;
        var userInterestsInfo = shuffleArray(interests);
        var columnNumber = 0;
        var circlesInColumn = 0;
        var circles = (userInterestsInfo || []).map(function (data, index) {
            var topError = columnNumber % 2 == ZERO ? ZERO : MINIMUM_REQUIRED_DISTANCE;
            var distanceFromLeft = columnNumber === 0 ? 10 : 5;
            var circle = __assign(__assign({}, data), { key: index, left: columnNumber * minDistanceBetweenTwoCircleCenters +
                    generateRandom(ERROR_FOR_CENTER) +
                    distanceFromLeft, top: circlesInColumn * minDistanceBetweenTwoCircleCenters +
                    generateRandom(ERROR_FOR_CENTER) +
                    topError, radius: radius });
            circlesInColumn++;
            if (circlesInColumn == maximumCirclesPerColumn) {
                columnNumber++;
                circlesInColumn = ZERO;
            }
            return circle;
        });
        return circles;
    };
    var renderInterest = function () {
        var radius = circleRadius ? circleRadius : DEFAULT_CIRCLE_RADIUS;
        var circles = plotCentersOfCircles(radius);
        setInterests(circles);
    };
    var renderCircles = function () {
        return (userInterests || []).map(function (data) {
            return generateCircle(data);
        });
    };
    return (React.createElement("div", { className: classnames$1(classes.mainContainer, "" + className), id: "container", ref: textInput }, renderCircles()));
};

var useStyles$e = makeStyles(function (theme) {
    return createStyles({
        root: {
            width: "100%",
            display: "flex",
            position: "relative",
            justifyContent: "space-evenly",
            paddingTop: theme.spacing(1),
            paddingBottom: theme.spacing(1),
            background: theme.palette.primary.contrastText,
            "& .MuiBottomNavigationAction-root": {
                color: theme.palette.background.paper
            },
            "& .Mui-selected": {
                color: theme.palette.primary.main
            }
        }
    });
});

var FooterNavigation = function (props) {
    var classes = useStyles$e();
    var onIconSelection = props.onIconSelection, footerIcons = props.footerIcons;
    var _a = useState(""), value = _a[0], setValue = _a[1];
    var renderIcons = function (data) {
        var styles = {
            width: data.width,
            height: data.height,
            style: data.style,
            viewBox: data.viewBox
        };
        // console.log("svg...", data);
        return (React.createElement(Svg, { svgStyleProps: styles, isSvg: true, transform: data.transform, path: data.path, fill: data.fill, ariaLabel: data.label }));
    };
    var bottomNavigationIcons = function (footerIcons) {
        return footerIcons.map(function (item) {
            return (React.createElement(BottomNavigationAction, { key: item.value, label: item.label, value: item.value, icon: renderIcons(item), onClick: onIconSelection(value) }));
        });
    };
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    return (React.createElement(BottomNavigation, { value: value, onChange: handleChange, showLabels: true, className: classes.root }, bottomNavigationIcons(footerIcons)));
};

var useStyles$d = makeStyles(function (theme) {
    return createStyles({
        footerContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            position: "sticky",
            width: "100%",
            left: 0,
            bottom: 0
        }
    });
});

var FooterContainer = function (props) {
    var _a = props.footerProps, onIconSelection = _a.onIconSelection, footerIcons = _a.footerIcons;
    var classes = useStyles$d();
    return (React.createElement("div", { className: classnames(classes.footerContainer, "" + props.className) },
        React.createElement(FooterNavigation, { onIconSelection: onIconSelection, footerIcons: footerIcons })));
};

var useStyles$c = makeStyles(function (theme) {
    var _a;
    return createStyles({
        filterMainContainer: {
            display: "flex",
            flexDirection: "column",
            backgroundColor: theme.palette.background.default,
            overflowX: "hidden",
            marginTop: "-2px"
        },
        filterHeaderContainer: {
            padding: "6px 5vw 0px",
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        },
        label: {
            fontSize: "24px",
            color: "rgb(68, 68, 68)",
            //@ts-ignore
            fontWeight: ((_a = theme === null || theme === void 0 ? void 0 : theme.typography) === null || _a === void 0 ? void 0 : _a.fontWeightRegular) || "normal",
            margin: theme.spacing(0)
        },
        filterMessage: {
            fontSize: theme.typography.subtitle1.fontSize,
            padding: theme.spacing(2, 0, 0, 0),
            color: theme.palette.primary.dark,
            cursor: "default",
            margin: "0px 0px 2px 10px"
        },
        filterWrapper: {
            padding: "9px 4vw",
            display: "flex",
            overflowX: "scroll",
            marginTop: "4px"
        },
        filterContainer: {
            display: "flex",
            flexFlow: "row nowrap",
            paddingRight: "calc(5vw - 9px)"
        },
        filterList: {
            border: "1.5px solid " + theme.palette.primary.dark,
            minWidth: "fit-content",
            margin: theme.spacing(0, 1.25),
            fontSize: theme.typography.h6.fontSize,
            borderRadius: theme.shape.borderRadius,
            transition: "background 350ms ease-out",
            cursor: "default",
            height: "39px",
            display: "flex",
            alignItems: "center",
            lineHeight: "21px",
            letterSpacing: "-0.06px",
            padding: theme.spacing(0, 2.25),
            whiteSpace: "nowrap"
        },
        filterShadow: {
            borderBottom: "1px solid rgb(208, 208, 208)",
            boxShadow: "rgba(0, 0, 0, 0.25) 0px 0px 10px 0px"
        },
        hideFilters: {
            display: "none"
        },
        selectedFiltersContainer: {
            display: "flex"
        },
        selectedFilters: {
            backgroundColor: theme.palette.primary.dark,
            minWidth: "fit-content",
            margin: theme.spacing(0, 1.25),
            fontSize: theme.typography.h6.fontSize,
            borderRadius: theme.shape.borderRadius,
            color: theme.palette.text.secondary,
            boxShadow: "rgba(0, 0, 0, 0.25) 0px 2px 10px 0px",
            transition: "background 350ms ease-out",
            cursor: "default",
            height: "39px",
            padding: theme.spacing(0, 2.25),
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center"
        },
        defaultButton: {
            border: "none",
            background: "none",
            color: "inherit",
            padding: "0px",
            margin: "0px"
        }
    });
});

var Filter = function (props) {
    var filters = props.filters, label = props.label, shouldSortBySelected = props.shouldSortBySelected, selectedFilters = props.selectedFilters, clear = props.clear, _a = props.tabIndex, tabIndex = _a === void 0 ? "0" : _a;
    var classes = useStyles$c();
    var _b = useState([]), filtersData = _b[0], setFiltersData = _b[1];
    var _c = useState([]), selectedFilterData = _c[0], setSelectedFilters = _c[1];
    var _d = useState(""), filterBoxShadow = _d[0], setFilterBoxShadow = _d[1];
    var rootElem = document.getElementById("root");
    useEffect(function () {
        rootElem && rootElem.addEventListener("scroll", onScroll);
    }, []);
    var onScroll = function () {
        if (rootElem && rootElem.scrollTop > 371) {
            setFilterBoxShadow(classes.filterShadow);
        }
        else {
            setFilterBoxShadow("");
        }
    };
    useEffect(function () {
        if ((filters === null || filters === void 0 ? void 0 : filters.length) > 0) {
            setFiltersData(__spreadArrays(filters));
        }
        var selectedFilterData = (filters || []).filter(function (filter) { return filter.isSelected === true; });
        setSelectedFilters(selectedFilterData);
    }, [filters]);
    var compareFilters = function (first, second) {
        if (first.isSelected === true && second.isSelected === true) {
            return second.selectOrder - first.selectOrder;
        }
        else if (first.isSelected === false && second.isSelected === false) {
            return first.position - second.position;
        }
        else
            return first.isSelected ? -1 : 1;
    };
    var selectAndClearFilter = function (name) {
        var updatedFilters = filtersData.map(function (f) {
            var filter = Object.assign({}, f);
            if (filter.name === name) {
                filter.isSelected = !filter.isSelected;
            }
            return filter;
        });
        var selectedFilterData = updatedFilters.filter(function (filter) { return filter.isSelected === true; });
        setFiltersData(updatedFilters);
        setSelectedFilters(selectedFilterData);
        selectedFilters(selectedFilterData);
    };
    var resetFilter = function () {
        var updatedFilters = filtersData.map(function (f) {
            var filter = Object.assign({}, f);
            filter.isSelected = false;
            return filter;
        });
        setSelectedFilters([]);
        setFiltersData(updatedFilters);
        clear();
    };
    var renderFilters = function (filter) {
        return (React.createElement("button", { onClick: function () { return selectAndClearFilter(filter.name); }, tabIndex: +tabIndex, className: classes.defaultButton, "aria-label": filter.label + " filter", key: filter.name },
            React.createElement("div", { className: filter.isSelected ? classes.selectedFilters : classes.filterList }, filter.label)));
    };
    return (React.createElement("div", { className: classes.filterMainContainer + " " + filterBoxShadow },
        React.createElement("div", { className: classes.filterHeaderContainer },
            React.createElement("h2", { className: classes.label }, label),
            selectedFilterData &&
                selectedFilterData.length &&
                selectedFilterData.length > 0 ? (React.createElement("button", { onClick: function () { return resetFilter(); }, tabIndex: 0, className: classes.defaultButton, "aria-label": "clear all filter" },
                React.createElement("div", { className: classes.filterMessage }, selectedFilterData.length === 1
                    ? "Clear filter"
                    : "Clear filters"))) : ("")),
        React.createElement("div", { className: classes.filterWrapper },
            React.createElement("div", { className: classes.filterContainer }, shouldSortBySelected
                ? filtersData.sort(compareFilters).map(function (item) {
                    return renderFilters(item);
                })
                : filtersData.map(function (item) {
                    return renderFilters(item);
                })))));
};

var useStyles$b = makeStyles$1(function (theme) {
    return createStyles$1({
        root: {
            position: "absolute"
        }
    });
});
var OverlayIcon = function (props) {
    var classes = useStyles$b();
    var url = props.url, altText = props.altText, size = props.size;
    var iconSize = size ? size : 32;
    var offset = "calc(50% - " + iconSize / 2 + "vw)";
    if (url)
        return (React.createElement("img", { className: classes.root, style: {
                top: offset,
                left: offset,
                height: iconSize + "vw",
                width: iconSize + "vw",
                zIndex: 9
            }, src: url, "aria-label": altText, alt: altText }));
    else
        return null;
};

var useStyles$a = makeStyles$1(function (theme) {
    return createStyles$1({
        hero: {
            position: "relative",
            marginTop: "0vw",
            opacity: 1,
            width: "100vw",
            marginLeft: "0vw"
        },
        largeImage: {
            //Old very me was using 45px padding in height also
            height: "calc(56vw + 45px)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "0 0",
            //This padding should be of same size of app bar/header
            backgroundSize: "cover",
            paddingTop: "45px"
        },
        carouselImage: {
            flex: "1 1 0%",
            zIndex: 0,
            //This needs to be picked from theme
            backgroundSize: "calc(100% + 20px)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "-10px -10px"
        },
        voucherImage: {
            flex: 1,
            zIndex: 0,
            display: "flex",
            //This needs to be picked from theme
            backgroundSize: "calc(100% + 20px)",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "-10px -10px"
        },
        sharedOn: {
            height: "28vw",
            margin: "10px auto"
        },
        posterGrid: {
            // borderRadius: "9px", //TODO Should be picked from theme
            // boxShadow: "0px 2px 10px 0px rgba(0, 0, 0, 0.25)", //TODO should be coming from theme/config/stylePop
            // height: "calc(125px + 25vw)",
            // overflow: "hidden",
            display: "flex",
            flex: "1 1 50vw",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            position: "relative",
            backgroundPosition: "center"
        },
        grid: {
            flex: 1,
            position: "relative",
            display: "flex",
            zIndex: 1
        },
        gridImage: {
            flex: 1,
            zIndex: 0,
            position: "relative",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "-5px -5px",
            backgroundSize: "calc(100% + 10px)"
        },
        mpSmallCard: {
            flex: 1,
            zIndex: 0,
            position: "relative",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "50px 0px",
            backgroundSize: "45%"
        },
        posterImage: {
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            width: "100%",
            position: "relative",
            backgroundPosition: "center"
        },
        horizontalImage: {
            flex: 1,
            zIndex: 0,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center"
        },
        posterContent: {
            // padding: "44vw 10px 10px"
            // padding: "0 10px 18px",
            position: "absolute",
            bottom: "0",
            height: "150px",
            display: "flex",
            boxSizing: "border-box",
            flexDirection: "column",
            justifyContent: "space-between"
        },
        posterGridContent: {
            // padding: "34vw 10px 10px",
            width: "100%",
            height: "120px",
            position: "absolute",
            bottom: 0,
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column"
        }
    });
});
var OfferImage = function (props) {
    var _a;
    var classes = useStyles$a();
    var mode = props.mode, imageDetails = props.imageDetails, isBlurred = props.isBlurred, orientation = props.orientation; props.onImageClick; var title = props.title, subTitle = props.subTitle, overlayIcon = props.overlayIcon, options = props.options;
    var overrideImageStyle = ((_a = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _a === void 0 ? void 0 : _a.Image) || {};
    var renderOverlayIcon = function (size) {
        if (isBlurred && overlayIcon)
            return (React.createElement(OverlayIcon, { url: overlayIcon === null || overlayIcon === void 0 ? void 0 : overlayIcon.url, altText: overlayIcon === null || overlayIcon === void 0 ? void 0 : overlayIcon.altText, size: size }));
    };
    var fullImage = function () {
        return (React.createElement("div", { className: classes.hero },
            React.createElement("div", { className: classes.largeImage, "aria-label": imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.altText, style: __assign({ backgroundImage: isBlurred
                        ? "linear-gradient(rgba(100, 100, 100, 0.3), rgba(100, 100, 100, 0.3)), url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) +
                            "')"
                        : "url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) + "')", filter: isBlurred ? "blur(5px)" : "blur(0)" }, overrideImageStyle) }),
            renderOverlayIcon()));
    };
    var carouselImage = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.carouselImage, "aria-label": imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.altText, style: __assign({ backgroundImage: isBlurred
                        ? "linear-gradient(rgba(100, 100, 100, 0.3), rgba(100, 100, 100, 0.3)), url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) +
                            "')"
                        : "url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) + "')", filter: isBlurred ? "blur(5px)" : "blur(0)" }, overrideImageStyle) }),
            renderOverlayIcon()));
    };
    var voucherImage = function () {
        var gradient = isBlurred
            ? "linear-gradient(rgba(100, 100, 100, 0.9), rgba(100, 100, 100, 0.9)), url('"
            : "";
        return (React.createElement("div", { className: classes.voucherImage, "aria-label": imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.altText, style: __assign({ backgroundImage: gradient + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) + "')", filter: isBlurred ? "blur(5px)" : "blur(0)" }, overrideImageStyle) }));
    };
    var posterGrid = function () {
        return (React.createElement("div", { className: classes.posterGrid, "aria-label": imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.altText, style: __assign({ backgroundImage: isBlurred
                    ? "linear-gradient(rgba(100, 100, 100, 0.3), rgba(100, 100, 100, 0.3)), url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) +
                        "')"
                    : "url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) + "')" }, overrideImageStyle) },
            React.createElement("div", { className: classes.posterGridContent },
                React.createElement("div", { style: {
                        fontSize: "18px",
                        fontWeight: 500,
                        marginBottom: "10px",
                        wordBreak: "break-word",
                        padding: "12px 12px 0",
                        lineHeight: "1",
                        fontFamily: "VodafoneRgBold"
                    } }, title),
                React.createElement("div", { style: { fontSize: "16px", padding: "0px 12px 12px" } }, subTitle))));
    };
    var grid = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.gridImage, "aria-label": imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.altText, style: __assign({ backgroundImage: isBlurred
                        ? "linear-gradient(rgba(100, 100, 100, 0.3), rgba(100, 100, 100, 0.3)), url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) +
                            "')"
                        : "url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) + "')", filter: isBlurred ? "blur(5px)" : "blur(0)" }, overrideImageStyle) }),
            renderOverlayIcon(16)));
    };
    var poster = function () {
        return (React.createElement("div", { className: classes.posterImage, "aria-label": imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.altText, style: __assign({ backgroundImage: isBlurred
                    ? "linear-gradient(rgba(100, 100, 100, 0.3), rgba(100, 100, 100, 0.3)), url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) +
                        "')"
                    : "url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) + "')", filter: isBlurred ? "blur(5px)" : "blur(0)" }, overrideImageStyle) },
            React.createElement("div", { className: classes.posterContent },
                React.createElement("h3", { style: {
                        fontSize: "22px",
                        fontFamily: "VodafoneRgBold",
                        fontWeight: 400,
                        lineHeight: 1,
                        wordBreak: "break-word",
                        margin: "0",
                        padding: "18px 5vw 0"
                    } }, title),
                React.createElement("div", { style: { fontSize: "18px", padding: "0px 5vw 18px" } }, subTitle))));
    };
    var horizontalImage = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.horizontalImage, "aria-label": imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.altText, style: __assign({ backgroundImage: isBlurred
                        ? "linear-gradient(rgba(100, 100, 100, 0.3), rgba(100, 100, 100, 0.3)), url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) +
                            "')"
                        : "url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) + "')", filter: isBlurred ? "blur(5px)" : "blur(0)" }, overrideImageStyle) }),
            renderOverlayIcon()));
    };
    var mpSmallCard = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.mpSmallCard, "aria-label": imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.altText, style: __assign({ backgroundImage: isBlurred
                        ? "linear-gradient(rgba(100, 100, 100, 0.3), rgba(100, 100, 100, 0.3)), url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) +
                            "')"
                        : "url('" + (imageDetails === null || imageDetails === void 0 ? void 0 : imageDetails.url) + "')", filter: isBlurred ? "blur(5px)" : "blur(0)" }, overrideImageStyle) }),
            renderOverlayIcon(16)));
    };
    var portraitImage = function () {
        return (React.createElement(Fragment, null,
            mode === "carousel" && carouselImage(),
            mode === "full" && fullImage(),
            mode === "voucher" && voucherImage(),
            mode === "posterGrid" && posterGrid(),
            mode === "grid" && grid(),
            mode === "poster" && poster(),
            mode === "mpSmallCard" && mpSmallCard()));
    };
    return (React.createElement(Fragment
    // onClick={() => {
    //   onImageClick && typeof onImageClick === "function"
    //     ? onImageClick()
    //     : "";
    // }}
    , null,
        orientation === "landscape" && horizontalImage(),
        orientation !== "landscape" && portraitImage()));
};

var useStyles$9 = makeStyles$1(function (theme) {
    return createStyles$1({
        mainContainer: {
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "row"
        },
        stripedBadgeText: {
            fontSize: theme.typography.subtitle2.fontSize,
            width: "100%",
            color: theme.palette.primary.contrastText,
            fontWeight: theme.typography.fontWeightRegular,
            padding: theme.spacing(0.7) + "px " + theme.spacing(3) + "px"
        },
        badge: {
            color: theme.palette.primary.contrastText,
            fontWeight: theme.typography.fontWeightBold,
            background: "-" + theme.spacing(5) + "px " + theme.spacing(0) + "px " + theme.palette.primary.main,
            boxShadow: theme.palette.primary.main + " " + theme.spacing(0) + "px " + theme.spacing(1) + "px " + theme.spacing(4) + "px -" + theme.spacing(1) + "px",
            "& .MuiChip-label": {
                padding: theme.spacing(0),
                fontFamily: theme.typography.h3.fontFamily
            }
        },
        iosLabel: {
            overflow: "hidden",
            fontFamily: theme.typography.h3.fontFamily,
            whiteSpace: "nowrap",
            padding: "0px",
            textOverflow: "ellipsis",
            letterSpacing: "-0.6px"
        },
        simpleLabel: {
            overflow: "hidden",
            fontFamily: theme.typography.h3.fontFamily,
            whiteSpace: "nowrap",
            padding: "0px",
            textOverflow: "ellipsis"
        },
        stripedBadge: {
            display: "flex",
            background: theme.palette.secondary.dark,
            width: "100%",
            alignItems: "center"
        }
    });
});

var BadgeType;
(function (BadgeType) {
    BadgeType[BadgeType["DEFAULT"] = 0] = "DEFAULT";
    BadgeType[BadgeType["OVERLAYSTRIP"] = 1] = "OVERLAYSTRIP";
    BadgeType[BadgeType["MPDEFAULT"] = 2] = "MPDEFAULT";
    BadgeType[BadgeType["OVERLAYSTRIPCUSTOM"] = 3] = "OVERLAYSTRIPCUSTOM";
})(BadgeType || (BadgeType = {}));

var Badge = function (props) {
    var classes = useStyles$9();
    var theme = useTheme();
    var badgeType = props.badgeType, badgeText = props.badgeText, badgeStyle = props.badgeStyle, mode = props.mode;
    var iOSDevice = function () {
        return ([
            "iPad Simulator",
            "iPhone Simulator",
            "iPod Simulator",
            "iPad",
            "iPhone",
            "iPod"
        ].includes(navigator.platform) ||
            // iPad on iOS 13 detection
            (navigator.userAgent.includes("Mac") && "ontouchend" in document));
    };
    var getStripStyle = function () {
        if (mode !== "grid") {
            return __assign({ height: "40px", padding: "0 18px", fontSize: "18px", display: "flex", alignItems: "center", paddingLeft: "5vw" }, badgeStyle);
        }
        else {
            return {};
        }
    };
    var getBadgeIconStyle = function () {
        if (mode === "grid") {
            return {
                margin: "0px -4px 0px 9px",
                height: "17px",
                width: "16px"
            };
        }
        else if (mode === "full") {
            return {
                margin: "1px 0px 1px 5vw",
                height: "28px",
                width: "26px"
            };
        }
        else if (mode === "poster") {
            return {
                margin: "1px 0px 1px 5vw",
                height: "28px",
                width: "26px"
            };
        }
        else {
            return {
                margin: "0px 0px 0px 5vw",
                height: "27px",
                width: "25px"
            };
        }
    };
    var stripBadgeStyle = function () {
        return __assign({ display: "flex", width: "100%", alignItems: "center" }, badgeStyle);
    };
    var renderStripedBadge = function () {
        return (React.createElement("div", { style: stripBadgeStyle() },
            (props === null || props === void 0 ? void 0 : props.showCustomBadgeIcon) && (React.createElement("img", { src: props === null || props === void 0 ? void 0 : props.customBadgeIcon, alt: "CustomBadge", style: getBadgeIconStyle() })),
            React.createElement("div", { className: classnames(classes.stripedBadgeText), style: getStripStyle() },
                React.createElement("span", null, badgeText))));
    };
    var renderCustomStripedBadge = function () {
        return (React.createElement("div", { style: badgeStyle },
            (props === null || props === void 0 ? void 0 : props.showCustomBadgeIcon) && (React.createElement("img", { src: props === null || props === void 0 ? void 0 : props.customBadgeIcon, alt: "CustomBadge" })),
            React.createElement("div", { style: { marginLeft: "5px" } },
                React.createElement("span", null, badgeText))));
    };
    var getOverlayStyle = function () {
        if (mode === "grid") {
            return __assign({ fontSize: "10px", boxShadow: "rgba(156, 42, 160, 0) 0px 5px 15px -5px", height: "20px", padding: "0 9px", paddingLeft: (props === null || props === void 0 ? void 0 : props.showCustomBadgeIcon) ? "2px" : "9px" }, badgeStyle);
        }
        if (mode === "full" || mode === "carousel") {
            return __assign({ padding: "0 12px", paddingLeft: (props === null || props === void 0 ? void 0 : props.showCustomBadgeIcon) ? "10px" : "12px", fontFamily: theme.typography.h3.fontFamily, fontSize: "18px", boxShadow: "rgba(156, 42, 160, 0) 0px 5px 15px -5px", height: "30px" }, badgeStyle);
        }
    };
    var renderOverlayBadge = function () {
        var style = getOverlayStyle();
        var showBadgeIcon = {};
        if (props === null || props === void 0 ? void 0 : props.showCustomBadgeIcon) {
            showBadgeIcon.avatar = (React.createElement("img", { style: {
                    margin: "0px",
                    marginRight: mode === "grid" ? "0px" : "2px",
                    height: "62%"
                }, src: props === null || props === void 0 ? void 0 : props.customBadgeIcon, alt: "CustomBadge" }));
        }
        return (React.createElement("div", { className: classes.mainContainer },
            React.createElement(Chip, __assign({ label: badgeText, classes: {
                    label: iOSDevice() ? classes.iosLabel : classes.simpleLabel
                }, className: classes.badge, style: style }, showBadgeIcon))));
    };
    var getMpDefaultBadgeStyle = function () {
        if (mode === "mpSmallCard") {
            return __assign({ fontSize: "15px", fontWeight: 700, padding: "12px 16px" }, badgeStyle);
        }
    };
    var renderMpDefaultBadge = function () {
        var style = getMpDefaultBadgeStyle();
        return (React.createElement("div", { className: classes.mainContainer },
            React.createElement("div", { style: style }, badgeText)));
    };
    return badgeType === BadgeType[BadgeType.OVERLAYSTRIP]
        ? renderStripedBadge()
        : badgeType === BadgeType[BadgeType.MPDEFAULT]
            ? renderMpDefaultBadge()
            : badgeType === BadgeType[BadgeType.OVERLAYSTRIPCUSTOM]
                ? renderCustomStripedBadge()
                : renderOverlayBadge();
};

var useStyles$8 = makeStyles$1(function (theme) {
    return createStyles$1({
        titleDefault: {
            margin: theme.spacing(1, 0),
            wordBreak: "break-word"
        },
        titleSmall: {
            margin: theme.spacing(0.25, 0),
            lineHeight: theme.typography.h5.lineHeight,
            wordBreak: "break-word"
        },
        mpSmallCardTitle: {
            wordBreak: "break-word",
            fontWeight: 100,
            lineHeight: "22px",
            fontSize: "12px",
            letterSpacing: "1px"
        },
        titleAnimated: {}
    });
});
var TitleComponent = function (props) {
    var _a;
    var classes = useStyles$8();
    var mode = props.mode, title = props.title, options = props.options, id = props.id;
    var overrideStyle = ((_a = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _a === void 0 ? void 0 : _a.Title) || {};
    var defaultTitle = function () {
        return (React.createElement(Typography, { className: classes.titleDefault, variant: "h3", style: overrideStyle, id: id }, title));
    };
    var smallTitle = function () {
        return (React.createElement(Typography, { className: classes.titleSmall, style: overrideStyle, variant: "h5", id: id }, title));
    };
    var mpSmallCardTitle = function () {
        return (React.createElement(Typography, { className: classes.mpSmallCardTitle, variant: "body1", style: overrideStyle }, title.length <= 42 ? title : title.substring(0, 42) + "..."));
    };
    var animatedTitle = function () {
        return React.createElement("div", { className: classes.titleAnimated }, defaultTitle());
    };
    return (React.createElement(Fragment, null,
        mode === "default" && defaultTitle(),
        mode === "grid" && smallTitle(),
        mode === "mpSmallCard" && mpSmallCardTitle(),
        mode === "animated" && animatedTitle()));
};

var useStyles$7 = makeStyles$1(function (theme) {
    return createStyles$1({
        subTitleDefault: {
            color: theme.typography.h4.color,
            fontWeight: "normal",
            margin: theme.spacing(5) + "px 0 0",
            lineHeight: theme.typography.h4.lineHeight
        },
        subTitleAnimated: {}
    });
});
var SubTitleComponent = function (props) {
    var _a;
    var classes = useStyles$7();
    var mode = props.mode, subTitle = props.subTitle, options = props.options;
    var overrideStyle = ((_a = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _a === void 0 ? void 0 : _a.SubTitle) || {};
    var defaultSubTitle = function () {
        return (React.createElement(Typography, { className: classes.subTitleDefault, variant: "h4", style: overrideStyle }, subTitle));
    };
    var animatedSubTitle = function () {
        return React.createElement("div", { className: classes.subTitleAnimated }, defaultSubTitle());
    };
    return (React.createElement(Fragment, null,
        mode === "default" && defaultSubTitle(),
        mode === "animated" && animatedSubTitle()));
};

var useStyles$6 = makeStyles$1(function (theme) {
    return createStyles$1({
        actionContainer: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end"
        },
        logoSmall: {
            maxHeight: "31px",
            maxWidth: "45px"
        },
        logoSmallLandscape: {
            maxHeight: "31px",
            maxWidth: "45px"
        },
        logoDefault: {
            maxHeight: "45px",
            maxWidth: "65px"
        },
        logoDefaultLandscape: {
            maxHeight: "45px",
            maxWidth: "65px"
        },
        favoriteContainer: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center"
        },
        defaultFavorite: {
            fill: "none",
            border: "1px",
            stroke: "black",
            strokeWidth: "1",
            strokeLinecap: "butt",
            strokeLinejoin: "miter",
            strokeMiterlimit: 10,
            strokeDasharray: "none",
            strokeOpacity: 1
        },
        fillFavorite: {
            fill: theme.palette.primary.main
        },
        fillMpFavourite: {
            fill: theme.palette.primary.light
        },
        savedText: {
            marginRight: "-45px",
            display: "none",
            fontSize: "17px"
        },
        savedTextAnimation: {
            animation: "$animateSave 1000ms ease-in-out",
            display: "block"
        },
        defaultButton: {
            border: "none",
            background: "none",
            padding: "0px",
            color: "inherit",
            display: "inline-grid"
        },
        "@keyframes animateSave": {
            "0%": {
                opacity: 0,
                marginRight: "-45px"
            },
            "40%": {
                opacity: 0.5,
                display: "none",
                marginRight: "4px"
            },
            "50%": {
                opacity: 1,
                display: "none",
                marginRight: "4px"
            },
            "60%": {
                opacity: 1,
                display: "none",
                marginRight: "4px"
            },
            "100%": {
                opacity: 0,
                marginRight: "-45px"
            }
        },
        titleTextAnimation: {
            animation: "$offerTitle 500ms ease-in-out"
        },
        "@keyframes offerTitle": {
            from: {
                transform: "translate(0px,-30px)",
                opacity: 0
            },
            to: {
                transform: "translate(0px,0px)",
                opacity: 1
            }
        }
    });
});
var CardAction = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var classes = useStyles$6();
    var mode = props.mode, logoDetails = props.logoDetails, orientation = props.orientation, showFavorite = props.showFavorite, isFavorite = props.isFavorite; props.isLocation; var onActionClicked = props.onActionClicked, actionElement = props.actionElement, options = props.options, _j = props.tabIndex, tabIndex = _j === void 0 ? "0" : _j, rest = __rest(props, ["mode", "logoDetails", "orientation", "showFavorite", "isFavorite", "isLocation", "onActionClicked", "actionElement", "options", "tabIndex"]);
    var showSavedAnimation = (rest === null || rest === void 0 ? void 0 : rest.showSavedAnimation) || false;
    var _k = useState(false), animateSaveText = _k[0], setAnimateSaveText = _k[1];
    var theme = useTheme$1();
    var actionElementProps = (actionElement === null || actionElement === void 0 ? void 0 : actionElement.props) || {};
    useEffect(function () {
        if (showSavedAnimation) {
            startSaveAnimation();
        }
    }, [showSavedAnimation]);
    var startSaveAnimation = function () {
        setAnimateSaveText(true);
        setTimeout(function () { return setAnimateSaveText(false); }, 1000);
    };
    var cardActionPadding;
    if (mode === "full" || mode === "default" || mode === "voucher") {
        cardActionPadding = "0 5vw 18px";
    }
    else if (mode === "poster") {
        cardActionPadding = "0px";
    }
    else if (mode === "mpSmallCard") {
        cardActionPadding = "12px 12px 0px";
    }
    else {
        cardActionPadding = "4px 12px 8px 12px";
    }
    var renderActionElement = function () {
        var _a, _b;
        var OverriddenActionComponent = ((_a = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _a === void 0 ? void 0 : _a.ActionElement) || undefined;
        if (typeof ((_b = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _b === void 0 ? void 0 : _b.ActionElement) === "function") {
            return (React.createElement("button", { className: classes.defaultButton, tabIndex: +tabIndex, "aria-label": "show reward code" },
                React.createElement("div", __assign({}, actionElementProps, { onClick: function (event) {
                        event.stopPropagation();
                        typeof onActionClicked == "function" && onActionClicked();
                    } }),
                    React.createElement(OverriddenActionComponent, null))));
        }
        else {
            if (!Object.keys(actionElementProps).length) {
                return null;
            }
            return (React.createElement("button", { className: classes.defaultButton, tabIndex: +tabIndex, "aria-label": "show reward code" },
                React.createElement("div", __assign({}, actionElementProps, { onClick: function (event) {
                        event.stopPropagation();
                        typeof onActionClicked == "function" && onActionClicked();
                    } }), actionElementProps === null || actionElementProps === void 0 ? void 0 : actionElementProps.children)));
        }
    };
    var getLogoClass = function () {
        if (orientation === "landscape") {
            if (mode === "grid") {
                return "logoSmallLandscape";
            }
            else {
                return "logoDefaultLandscape";
            }
        }
        else {
            if (mode === "grid") {
                return "logoSmall";
            }
            else {
                return "logoDefault";
            }
        }
    };
    var animateClassName = animateSaveText ? classes.savedTextAnimation : "";
    var fColor = "none";
    if (isFavorite) {
        fColor = (options === null || options === void 0 ? void 0 : options.actionElementStyle) ? options.actionElementStyle.fillColor
            : theme.palette.primary.main;
    }
    var CTAComponent = ((_a = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _a === void 0 ? void 0 : _a.CTAComponent) || undefined;
    var overrideActionContainerStyle = ((_b = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _b === void 0 ? void 0 : _b.ActionContainer) || {};
    var overrideActionElementContainerStyle = ((_c = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _c === void 0 ? void 0 : _c.ActionElementContainer) || {};
    var overrideActionElementStyle = ((_d = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _d === void 0 ? void 0 : _d.ActionElement) || {};
    var overrideLogoStyle = ((_e = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _e === void 0 ? void 0 : _e.Logo) || {};
    var overrideLogoContainerStyle = ((_f = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _f === void 0 ? void 0 : _f.LogoContainer) || {};
    return (React.createElement(Fragment, null,
        React.createElement("div", { style: { paddingTop: mode === "full" ? "12px" : "0" } },
            React.createElement("div", { className: classes.actionContainer, style: __assign({ padding: cardActionPadding }, overrideActionContainerStyle) },
                React.createElement("div", { style: overrideLogoContainerStyle },
                    React.createElement("img", { className: classes[getLogoClass()] + " " + ((rest === null || rest === void 0 ? void 0 : rest.showTitleTextAnimation) ? classes.titleTextAnimation : ""), onLoad: function (event) {
                            var elem = event.target;
                            if (elem.naturalWidth <= elem.naturalHeight) {
                                if (mode === "grid") {
                                    elem.style.maxWidth = theme.spacing(6.25) + "px";
                                }
                                else {
                                    elem.style.maxWidth = theme.spacing(10) + "px";
                                }
                            }
                        }, style: overrideLogoStyle, src: logoDetails === null || logoDetails === void 0 ? void 0 : logoDetails.url, "aria-label": logoDetails === null || logoDetails === void 0 ? void 0 : logoDetails.altText, alt: logoDetails === null || logoDetails === void 0 ? void 0 : logoDetails.altText })),
                CTAComponent && typeof CTAComponent === "function" ? (React.createElement(CTAComponent, null)) : (""),
                React.createElement("div", { className: classes.favoriteContainer, style: overrideActionElementContainerStyle }, showFavorite
                    ? showFavorite && (React.createElement(React.Fragment, null,
                        React.createElement("div", { className: classes.savedText + " " + animateClassName }, "Saved!"),
                        React.createElement("button", { tabIndex: +tabIndex, className: classes.defaultButton, onClick: function (event) {
                                event.stopPropagation();
                                typeof onActionClicked == "function" &&
                                    onActionClicked();
                            }, "aria-label": "favourite offer" },
                            React.createElement(Svg, { svgStyleProps: {
                                    className: isFavorite
                                        ? classes.fillFavorite
                                        : classes.defaultFavorite,
                                    width: mode === "full"
                                        ? theme.spacing(6) + "px"
                                        : theme.spacing(5.5) + "px",
                                    height: mode === "full"
                                        ? theme.spacing(6) + "px"
                                        : theme.spacing(5.5) + "px",
                                    viewBox: mode === "full"
                                        ? "-1 -4 21.6 21.6"
                                        : "-0.5 -1 18.5 18.5",
                                    style: __assign({ fill: fColor, display: "inline-block", transition: "fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms", flexShrink: 0 }, overrideActionElementStyle),
                                    stroke: (options === null || options === void 0 ? void 0 : options.actionElementStyle) ? options.actionElementStyle.strokeColor
                                        : theme.palette.primary.main
                                }, isSvg: true, transform: "", path: "m 8.277028,16.55172 c -0.093092,0 -0.183481,-0.03129 -0.256559,-0.08896 C 6.641918,15.33585 5.356666,14.09942 4.177255,12.76552 1.569249,9.818276 0.1664502,7.115172 0.00816981,4.732759 -0.06542375,3.546545 0.3607306,2.383657 1.183376,1.525862 2.092617,0.555149 3.362387,0.00301 4.692442,0 6.141669,0.00361228 7.507009,0.6801473 8.387721,1.831034 9.228994,0.6914172 10.55688,0.01331898 11.97334,0 c 2.51697,0 4.56531,2.147586 4.57358,4.79069 0.02897,0.40862 0.16656,5.167241 -8.012298,11.67103 -0.073219,0.05826 -0.164023,0.09 -0.257594,0.09 z", fill: "", ariaLabel: isFavorite
                                    ? (_g = options === null || options === void 0 ? void 0 : options.cardActionAltText) === null || _g === void 0 ? void 0 : _g.saveAltText : (_h = options === null || options === void 0 ? void 0 : options.cardActionAltText) === null || _h === void 0 ? void 0 : _h.unsaveAltText }))))
                    : renderActionElement())))));
};

var useStyles$5 = makeStyles$1(function (theme) {
    return createStyles$1({
        mainContainer: {
            background: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            display: "flex"
        },
        stripWrapper: {
            display: "flex",
            flexDirection: "column",
            margin: "18px 5vw",
            boxSizing: "border-box"
        },
        stripHeading: {
            fontFamily: theme.typography.fontFamily,
            fontSize: "24px",
            color: theme.palette.primary.contrastText,
            margin: 0,
            fontWeight: theme.typography.fontWeightBold
        },
        stripContent: {
            margin: theme.spacing(12.25) + "px " + theme.spacing(0) + "px " + theme.spacing(0) + "px"
        },
        stripContentWrapper: {
            fontSize: "20px",
            width: "100%",
            padding: theme.spacing(1.5, 2.5, 1.5, 5)
        },
        richText: {
            fontFamily: theme.typography.fontFamily,
            fontSize: "24px",
            letterSpacing: "0.7px",
            lineHeight: "28px",
            "& p": {
                color: theme.palette.primary.contrastText,
                lineHeight: "28px",
                letterSpacing: "0px"
            }
        }
    });
});

var InformationStrip = function (props) {
    var classes = useStyles$5();
    var content = props.content, heading = props.heading;
    var handleText = function (content) {
        return (React.createElement("div", { className: classes.richText, dangerouslySetInnerHTML: { __html: content } }));
    };
    var renderFullContent = function () {
        return (React.createElement("div", { className: classes.stripWrapper },
            React.createElement("h2", { className: classes.stripHeading }, handleText(heading)),
            React.createElement("div", { className: classes.stripContent }, handleText(content))));
    };
    var renderOnlyContent = function () {
        return React.createElement("div", { className: classes.stripContentWrapper }, content);
    };
    return (React.createElement("div", { className: classes.mainContainer }, heading ? renderFullContent() : renderOnlyContent()));
};

var AnimationHelper = function (_a) {
    var units = _a.units, defaultStyles = _a.defaultStyles, enterStyles = _a.enterStyles, children = _a.children, showEnterAnimation = _a.showEnterAnimation, rest = __rest(_a, ["units", "defaultStyles", "enterStyles", "children", "showEnterAnimation"]);
    var _b = useState(false), startEnterAnimation = _b[0], setStartEnterAnimation = _b[1];
    var _c = useState(false), startLeaveAnimation = _c[0], setStartLeaveAnimation = _c[1];
    var showExitAnimation = (rest === null || rest === void 0 ? void 0 : rest.showExitAnimation) || false;
    useEffect(function () {
        if (rest === null || rest === void 0 ? void 0 : rest.enterAnimationDelay) {
            setTimeout(function () { return setStartEnterAnimation(showEnterAnimation); }, rest === null || rest === void 0 ? void 0 : rest.enterAnimationDelay);
        }
        else {
            setStartEnterAnimation(showEnterAnimation);
        }
        if (rest === null || rest === void 0 ? void 0 : rest.exitAnimationDelay) {
            setTimeout(function () { return setStartLeaveAnimation(showExitAnimation); }, rest === null || rest === void 0 ? void 0 : rest.exitAnimationDelay);
        }
        else {
            setStartLeaveAnimation(showExitAnimation);
        }
    }, [showEnterAnimation, showExitAnimation]);
    var applyUnits = function (styles) {
        var stylesWithUnits = __assign({}, styles);
        Object.keys(styles).forEach(function (property) {
            if (units[property]) {
                stylesWithUnits[property] = stylesWithUnits[property] + units[property];
            }
        });
        return stylesWithUnits;
    };
    var AnimationStyle = __assign(__assign({}, (startEnterAnimation ? enterStyles : {})), (startLeaveAnimation ? rest === null || rest === void 0 ? void 0 : rest.exitStyles : {}));
    return (React.createElement(Motion, { defaultStyle: defaultStyles || {}, style: AnimationStyle }, function (interploatedStyles) { return (React.createElement("div", { style: applyUnits(interploatedStyles) }, children)); }));
};

var useStyles$4 = makeStyles$1(function (theme) {
    return createStyles$1({
        cardContainer: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1],
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: "calc(45vw + 150px)"
        },
        posterCardContainer: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1],
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        },
        fullCardContainer: {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            width: "100vw"
        },
        gridContainer: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[2],
            height: "calc(25vw + 125px)",
            flex: "1 1 50vw",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        },
        imageContainer: {
            display: "flex",
            position: "relative",
            zIndex: 1,
            flex: "1 1 0%",
            boxSizing: "border-box"
        },
        defaultBody: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            boxSizing: "border-box",
            backgroundColor: theme.palette.background.default,
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius
        },
        horizontalBody: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "150px",
            boxSizing: "border-box",
            backgroundColor: theme.palette.background.default
        },
        pushDownContainer: {
            alignSelf: "flex-end",
            width: "100%"
        },
        overlayTextContainer: {
            display: "none"
        },
        textContainer: {
            padding: "18px 5vw 0",
            overflow: "hidden"
        },
        gridTextContainer: {
            padding: theme.spacing(3) + "px " + theme.spacing(3) + "px 0",
            overflow: "hidden"
        },
        fullTextContainer: {
            display: "flex",
            flexDirection: "column",
            margin: "16px 5vw 17px",
            boxSizing: "border-box"
        },
        defaultButton: {
            border: "none",
            background: "none",
            padding: "0px",
            width: "100%",
            textAlign: "left",
            display: "inline-grid",
            color: "inherit"
        },
        titleTextAnimation: {
            animation: "$offerTitle 500ms ease-in-out"
        },
        "@keyframes offerTitle": {
            from: {
                transform: "translate(0px,-30px)",
                opacity: 0
            },
            to: {
                transform: "translate(0px,0px)",
                opacity: 1
            }
        },
        titleTextExitAnimation: {
            animation: "$offerTitleExit 600ms ease-in-out",
            opacity: 0
        },
        "@keyframes offerTitleExit": {
            from: {
                transform: "translate(0px,0px)",
                opacity: 1
            },
            to: {
                transform: "translate(0px,-30px)",
                opacity: 0
            }
        }
    });
});
var OfferCard = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var classes = useStyles$4();
    var theme = useTheme$1();
    var imageDetails = props.imageDetails, mode = props.mode, title = props.title, subTitle = props.subTitle, isBlurred = props.isBlurred, orientation = props.orientation, logoDetails = props.logoDetails, showFavorites = props.showFavorites, style = props.style, isFavorite = props.isFavorite, onActionClicked = props.onActionClicked, onClick = props.onClick, uniqueId = props.uniqueId, actionElement = props.actionElement, badge = props.badge, options = props.options, informationStripDetails = props.informationStripDetails, animationProps = props.animationProps, _h = props.tabIndex, tabIndex = _h === void 0 ? "0" : _h, rest = __rest(props, ["imageDetails", "mode", "title", "subTitle", "isBlurred", "orientation", "logoDetails", "showFavorites", "style", "isFavorite", "onActionClicked", "onClick", "uniqueId", "actionElement", "badge", "options", "informationStripDetails", "animationProps", "tabIndex"]);
    var _j = useState({
        imageMode: "carousel",
        titleMode: "default",
        subTitleMode: "default",
        cardActionMode: "default"
    }); _j[0]; _j[1];
    var _k = useState({
        bodyHeight: "120px",
        containerClass: "gridContainer",
        textClass: "gridTextContainer"
    }); _k[0]; _k[1];
    var defaultBadgeStyle = {
        margin: "0",
        defaultBodyPaddingTop: "5px",
        top: "0",
        position: "absolute"
    };
    var OverriddenOfferImage = ((_a = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _a === void 0 ? void 0 : _a.OfferImage) || {};
    var ContentComponent = ((_b = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _b === void 0 ? void 0 : _b.ContentComponent) || undefined;
    var overrideImageContainerStyle = ((_c = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _c === void 0 ? void 0 : _c.ImageContainer) || {};
    var overrideBadgeStyle = ((_d = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _d === void 0 ? void 0 : _d.BadgeStyle) || {};
    var overrideBadgeContainerStyle = ((_e = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _e === void 0 ? void 0 : _e.BadgeContainer) || {};
    var overrideBottomContainerStyle = ((_f = options === null || options === void 0 ? void 0 : options.overrideStyle) === null || _f === void 0 ? void 0 : _f.BottomContainer) || {};
    var renderModeStyles = {
        full: {
            renderMode: {
                imageMode: "full",
                titleMode: "animated",
                subTitleMode: "animated",
                cardActionMode: "full"
            },
            modeStyles: {
                bodyHeight: "fit-content",
                containerClass: "fullCardContainer",
                textClass: "fullTextContainer"
            }
        },
        grid: {
            renderMode: {
                imageMode: "grid",
                titleMode: "grid",
                cardActionMode: "grid"
            },
            modeStyles: {
                bodyHeight: "120px",
                containerClass: "gridContainer",
                textClass: "gridTextContainer"
            }
        },
        poster: {
            renderMode: {
                imageMode: "poster",
                titleMode: "default",
                cardActionMode: "poster"
            },
            modeStyles: {
                bodyHeight: "",
                containerClass: "posterCardContainer",
                textClass: "overlayTextContainer"
            }
        },
        posterGrid: {
            renderMode: {
                imageMode: "posterGrid",
                titleMode: "grid",
                cardActionMode: "poster"
            },
            modeStyles: {
                bodyHeight: "",
                containerClass: "gridContainer",
                textClass: "overlayTextContainer"
            }
        },
        voucher: {
            renderMode: {
                imageMode: "voucher",
                titleMode: "default",
                cardActionMode: "voucher"
            },
            modeStyles: {
                bodyHeight: "150px",
                containerClass: "cardContainer",
                textClass: "textContainer"
            }
        },
        carousel: {
            renderMode: {
                imageMode: "carousel",
                titleMode: "default",
                cardActionMode: "default"
            },
            modeStyles: {
                bodyHeight: "150px",
                containerClass: "cardContainer",
                textClass: "textContainer"
            }
        }
    };
    var getBadgeType = function () {
        if (badge && (badge === null || badge === void 0 ? void 0 : badge.badgeType)) {
            var badgeType = badge === null || badge === void 0 ? void 0 : badge.badgeType;
            var styles = badgeType === BadgeType[BadgeType.OVERLAYSTRIP]
                ? {
                    margin: "0",
                    defaultBodyPaddingTop: "5px",
                    top: "0px",
                    position: "relative"
                }
                : {
                    margin: mode === "grid" ? "0px 12px" : "0px 5vw",
                    defaultBodyPaddingTop: "5px",
                    top: mode === "full" || mode === "carousel" ? "-16px" : "-10.5px",
                    position: "absolute"
                };
            return styles;
        }
        else {
            return defaultBadgeStyle;
        }
    };
    var badgeStyle = getBadgeType();
    //styles for animation
    var defaultStyles = {
        marginTop: 120,
        opacity: 0,
        width: 0,
        marginLeft: 20
    };
    var enterStyles = {
        marginTop: spring(0),
        opacity: spring(1),
        width: spring(100),
        marginLeft: spring(0)
    };
    var leaveStyles = {
        marginTop: spring(60),
        opacity: spring(0),
        width: spring(100),
        marginLeft: spring(0)
    };
    ({
        marginTop: spring(0),
        opacity: spring(1)
    });
    ({
        marginTop: spring(-40),
        opacity: spring(0)
    });
    var titleAnimation = {
        defaultStyles: {
            marginTop: -40,
            opacity: 0
        },
        enterStyles: {
            marginTop: spring(0),
            opacity: spring(1)
        },
        exitStyles: {
            marginTop: spring(-40),
            opacity: spring(0)
        },
        units: {
            marginTop: "px",
            marginBottom: "px"
        }
    };
    var renderOfferImage = function () {
        var _a;
        var renderMode = renderModeStyles[mode].renderMode;
        return typeof ((_a = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _a === void 0 ? void 0 : _a.OfferImage) === "function" ? (React.createElement("div", { className: classes.imageContainer },
            React.createElement(OverriddenOfferImage, null))) : (React.createElement("div", { className: classes.imageContainer, style: __assign({ backgroundColor: isBlurred
                    ? "#1E696969"
                    : theme.palette.background.default }, overrideImageContainerStyle) },
            React.createElement(OfferImage, { mode: renderMode.imageMode, imageDetails: imageDetails, isBlurred: isBlurred, title: title, subTitle: subTitle, options: options, overlayIcon: options === null || options === void 0 ? void 0 : options.overlayIcon })));
    };
    var renderTitle = function () {
        var renderMode = renderModeStyles[mode].renderMode;
        return (React.createElement(TitleComponent, { title: title, options: options, mode: renderMode.titleMode, id: uniqueId }));
    };
    var renderSubtitle = function () {
        var renderMode = renderModeStyles[mode].renderMode;
        return (React.createElement(SubTitleComponent, { options: options, subTitle: subTitle || "", mode: renderMode.subTitleMode ? renderMode.subTitleMode : "default" }, "Offer SubTitle"));
    };
    useEffect(function () {
        if (mode === "grid") {
            var id = (uniqueId === null || uniqueId === void 0 ? void 0 : uniqueId.toString()) || "";
            var el = document.getElementById(id);
            if (el) {
                var lines = void 0;
                var fontSize = parseInt(window.getComputedStyle(el)["font-size"]);
                var lineHeight = parseInt(window.getComputedStyle(el)["line-height"]);
                var divHeight = el.offsetHeight;
                if (fontSize > 18) {
                    lines = divHeight / lineHeight;
                }
                if (lines > 2) {
                    el.style.cssText =
                        "display:-webkit-box ;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden";
                }
            }
        }
        if (mode === "carousel") {
            var id = (uniqueId === null || uniqueId === void 0 ? void 0 : uniqueId.toString()) || "";
            var el = document.getElementById(id);
            if (el) {
                var lines = void 0;
                var fontSize = parseInt(window.getComputedStyle(el)["font-size"]);
                var lineHeight = parseInt(window.getComputedStyle(el)["line-height"]);
                var divHeight = el.offsetHeight;
                if (fontSize > 22) {
                    lines = divHeight / lineHeight;
                }
                if (lines > 2) {
                    el.style.cssText =
                        "display:-webkit-box ;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden";
                }
            }
        }
    }, []);
    var renderCardFooter = function () {
        var animate = (rest === null || rest === void 0 ? void 0 : rest.showAnimation) && !(rest === null || rest === void 0 ? void 0 : rest.showCarouselAnimation) && mode === "full";
        var showCarouselEnterAnimation = ((rest === null || rest === void 0 ? void 0 : rest.showCarouselAnimation) && (animationProps === null || animationProps === void 0 ? void 0 : animationProps.showEnterAnimation) &&
            classes.titleTextAnimation) ||
            "";
        var showCarouselExitAnimation = ((rest === null || rest === void 0 ? void 0 : rest.showCarouselAnimation) && (animationProps === null || animationProps === void 0 ? void 0 : animationProps.showExitAnimation) &&
            classes.titleTextExitAnimation) ||
            "";
        var _a = renderModeStyles[mode], renderMode = _a.renderMode, modeStyles = _a.modeStyles;
        return (React.createElement("div", { className: classes.defaultBody, style: {
                height: modeStyles.bodyHeight
            }, id: "mainContainer" },
            React.createElement("div", { className: classes[modeStyles.textClass] + " " + showCarouselEnterAnimation + " " + showCarouselExitAnimation, id: "textContainer" },
                animate ? (React.createElement(AnimationHelper, __assign({}, titleAnimation, (animationProps || { showEnterAnimation: false }), { enterAnimationDelay: 320, exitAnimationDelay: 100 }), renderTitle())) : (renderTitle()),
                subTitle && subTitle.length ? (animate ? (React.createElement(AnimationHelper, __assign({}, titleAnimation, (animationProps || { showEnterAnimation: false }), { enterAnimationDelay: 400, exitAnimationDelay: 100 }),
                    React.createElement(React.Fragment, null, renderSubtitle()))) : (renderSubtitle())) : ("")),
            mode !== "posterGrid" && mode !== "poster" && (React.createElement(CardAction, { logoDetails: logoDetails, mode: renderMode.cardActionMode, orientation: orientation, showFavorite: showFavorites, isFavorite: isFavorite, onActionClicked: function () {
                    onActionClicked && onActionClicked(uniqueId ? uniqueId : "");
                }, actionElement: actionElement, options: options, showSavedAnimation: (rest === null || rest === void 0 ? void 0 : rest.showSavedAnimation) || false, showTitleTextAnimation: (rest === null || rest === void 0 ? void 0 : rest.showCarouselAnimation) && (animationProps === null || animationProps === void 0 ? void 0 : animationProps.showEnterAnimation), tabIndex: tabIndex }))));
    };
    return (React.createElement("button", { className: classes.defaultButton, onClick: function () {
            onClick && onClick(uniqueId ? uniqueId : "");
        }, tabIndex: +tabIndex, "aria-label": title + " reward" },
        React.createElement("div", { className: classes[renderModeStyles[mode].modeStyles.containerClass], 
            // TODO compute this based on orientation
            style: style },
            (rest === null || rest === void 0 ? void 0 : rest.showAnimation) &&
                !(rest === null || rest === void 0 ? void 0 : rest.showCarouselAnimation) &&
                mode === "full" ? (React.createElement(AnimationHelper, __assign({ enterStyles: enterStyles, exitStyles: leaveStyles, defaultStyles: defaultStyles, exitAnimationDelay: 240, units: {
                    marginTop: "vw",
                    marginLeft: "vw",
                    width: "%"
                } }, (animationProps || { showEnterAnimation: false })), renderOfferImage())) : (renderOfferImage()),
            informationStripDetails ? (React.createElement(InformationStrip, { heading: informationStripDetails === null || informationStripDetails === void 0 ? void 0 : informationStripDetails.heading, content: informationStripDetails === null || informationStripDetails === void 0 ? void 0 : informationStripDetails.content })) : (""),
            ContentComponent &&
                typeof ((_g = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _g === void 0 ? void 0 : _g.ContentComponent) === "function" ? (React.createElement(ContentComponent, null)) : (""),
            React.createElement("div", { className: classes.pushDownContainer, style: __assign({ position: "relative" }, overrideBottomContainerStyle) },
                badge ? (React.createElement("div", { style: __assign({ position: badgeStyle.position, top: badgeStyle.top, zIndex: 1, margin: badgeStyle.margin, width: "100%" }, overrideBadgeContainerStyle) },
                    React.createElement(Badge, { mode: mode, badgeType: badge === null || badge === void 0 ? void 0 : badge.badgeType, badgeText: badge === null || badge === void 0 ? void 0 : badge.badgeText, badgeStyle: __assign(__assign({}, badge === null || badge === void 0 ? void 0 : badge.badgeStyle), overrideBadgeStyle), showCustomBadgeIcon: badge === null || badge === void 0 ? void 0 : badge.showCustomBadgeIcon, customBadgeIcon: badge === null || badge === void 0 ? void 0 : badge.customBadgeIcon }))) : (""),
                renderCardFooter()))));
};

var useStyles$3 = makeStyles$1(function (theme) {
    return createStyles$1({
        root: {
            textAlign: "left",
            position: "relative"
        },
        countDownEndMessage: {
        // textAlign: "left"
        },
        countDownNumber: {
        // textAlign: "left"
        },
        countDownLabel: {
            // textAlign: "left",
            marginLeft: theme.spacing(0.75),
            alignSelf: "flex-end",
            paddingBottom: theme.spacing(1.25),
            lineHeight: "1.2"
        },
        countDownDelimiter: {
            margin: "0px 15px 0px 2px"
        },
        timerContainer: {
            display: "inline-flex",
            flexDirection: "row",
            marginTop: "-2px"
        }
    });
});
var CountDownTimer = function (props) {
    var countDownEndMessage = props.countDownEndMessage, headerInfoText = props.headerInfoText, remainingTicks = props.remainingTicks, options = props.options, styleOptions = props.styleOptions, style = props.style;
    var classes = useStyles$3();
    var renderer = function (_a) {
        var days = _a.days, hours = _a.hours, minutes = _a.minutes, seconds = _a.seconds, completed = _a.completed;
        if (completed) {
            if (completed) {
                // Render a completed state
                return (React.createElement("div", { className: classes.root, style: style },
                    React.createElement("div", { className: classes.countDownEndMessage, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.countDownEndMessageStyle }, countDownEndMessage || "Your voucher code has expired")));
            }
        }
        else {
            return (React.createElement("div", { className: classes.root, style: style },
                React.createElement("div", { style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.headerInfoStyle }, headerInfoText),
                React.createElement("div", { className: classes.timerContainer },
                    React.createElement(Typography, { variant: "h1", className: classes.countDownNumber, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerNumbersStyle }, days),
                    React.createElement(Typography, { variant: "subtitle2", className: classes.countDownLabel, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerLabelsStyle }, (options === null || options === void 0 ? void 0 : options.daysLabel) || "D"),
                    React.createElement("span", { className: classes.countDownDelimiter, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerDelimitersStyle }, options === null || options === void 0 ? void 0 : options.daysDelimiter),
                    React.createElement(Typography, { variant: "h1", className: classes.countDownNumber, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerNumbersStyle }, hours),
                    React.createElement(Typography, { variant: "subtitle2", className: classes.countDownLabel, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerLabelsStyle }, (options === null || options === void 0 ? void 0 : options.hoursLabel) || "H"),
                    React.createElement("span", { className: classes.countDownDelimiter, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerDelimitersStyle }, options === null || options === void 0 ? void 0 : options.hoursDelimiter),
                    React.createElement(Typography, { variant: "h1", className: classes.countDownNumber, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerNumbersStyle }, minutes),
                    React.createElement(Typography, { variant: "subtitle2", className: classes.countDownLabel, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerLabelsStyle }, (options === null || options === void 0 ? void 0 : options.minutesLabel) || "M"),
                    (options === null || options === void 0 ? void 0 : options.hideLastDelimiter) && (options === null || options === void 0 ? void 0 : options.hideSeconds) ? ("") : (React.createElement(React.Fragment, null,
                        React.createElement("span", { className: classes.countDownDelimiter, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerDelimitersStyle }, options === null || options === void 0 ? void 0 : options.minutesDelimiter))),
                    (options === null || options === void 0 ? void 0 : options.hideSeconds) ? ("") : (React.createElement(React.Fragment, null,
                        React.createElement(Typography, { variant: "h1", className: classes.countDownNumber, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerNumbersStyle }, seconds),
                        React.createElement(Typography, { variant: "subtitle2", className: classes.countDownLabel, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerLabelsStyle }, (options === null || options === void 0 ? void 0 : options.secondsLabel) || "S"),
                        (options === null || options === void 0 ? void 0 : options.hideLastDelimiter) ? ("") : (React.createElement(React.Fragment, null,
                            React.createElement("span", { className: classes.countDownDelimiter, style: styleOptions === null || styleOptions === void 0 ? void 0 : styleOptions.timerDelimitersStyle }, options === null || options === void 0 ? void 0 : options.secondsDelimiter))))))));
        }
    };
    return (React.createElement(Fragment, null,
        React.createElement(Countdown, { onComplete: function (delta) {
                if (typeof (options === null || options === void 0 ? void 0 : options.onComplete) === "function") {
                    return options.onComplete(delta);
                }
            }, date: remainingTicks, renderer: renderer })));
};

var styles = makeStyles(function (theme) { return ({
    input: {
        backgroundColor: theme.palette.background.paper,
        "& .MuiFilledInput-root": {
            borderRadius: theme.spacing(2.5) + "px",
            backgroundColor: theme.palette.background.paper
        }
    }
}); });
var CustomAutocomplete = function (props) {
    styles();
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var _b = React.useState(undefined), searchText = _b[0], setSearchText = _b[1];
    var _c = React.useState(false), showNoOptionsError = _c[0], setShowNoOptionsError = _c[1];
    var _d = React.useState([]), groupedOptions = _d[0], setGroupedOptions = _d[1];
    var theme = useTheme();
    var label = props.label, id = props.id, disableClearable = props.disableClearable, typographyVariant = props.typographyVariant, autoCompleteOptions = props.autoCompleteOptions; props.disabled; var autocompleteStyle = props.autocompleteStyle, labelStyle = props.labelStyle, linkStyle = props.linkStyle; props.freeSolo; var autoSuggestTextChanged = props.autoSuggestTextChanged, autoCompleteValueChanged = props.autoCompleteValueChanged, loading = props.loading; props.multiple; var debounceInterval = props.debounceInterval, externalApiCall = props.externalApiCall, fieldPlaceholder = props.fieldPlaceholder, showPopover = props.showPopover, sortResult = props.sortResult, linkTypographyVariant = props.linkTypographyVariant, noOptionsText = props.noOptionsText, popperClassName = props.popperClassName, inputClassName = props.inputClassName, groupLabelStyle = props.groupLabelStyle, searchIconStyle = props.searchIconStyle;
    var debouncedText = useDebounce(searchText, debounceInterval ? debounceInterval : 1000)[0];
    useEffect(function () {
        if (externalApiCall &&
            autoSuggestTextChanged &&
            debouncedText !== undefined) {
            autoSuggestTextChanged(debouncedText);
        }
    }, [debouncedText]);
    useEffect(function () {
        setGroupedOptions([]);
        setOpen(showPopover && searchText && !loading ? true : false);
        if (!showPopover) {
            filterOptions(autoCompleteOptions, "");
        }
    }, [autoCompleteOptions, showPopover, loading]);
    var filterOptions = function (autoCompleteOptions, filterText) {
        var options = filterText ? [] : autoCompleteOptions;
        setShowNoOptionsError(false);
        setGroupedOptions([]);
        if (filterText) {
            options = autoCompleteOptions.filter(function (opt) {
                if (opt.name &&
                    opt.name.toLowerCase().indexOf(filterText.toLowerCase()) > -1)
                    return opt;
            });
        }
        if (options && options.length) {
            var data = options.reduce(function (r, e) {
                // get first letter of name of current element
                var group = e.groupBy;
                // if there is no property in accumulator with this letter create it
                if (!r[group])
                    r[group] = { group: group, children: [e] };
                // if there is push current element to children array for that letter
                else
                    r[group].children.push(e);
                // return accumulator
                return r;
            }, {});
            var groupedOptions_1 = Object.values(data);
            //sorting array
            if (sortResult) {
                var result = groupedOptions_1.sort(function (a, b) { return -b.group.localeCompare(a.group); });
                setGroupedOptions(result);
            }
            else {
                // since data at this point is an object, to get array of values
                // we use Object.values method
                setGroupedOptions(groupedOptions_1);
            }
        }
        else {
            setShowNoOptionsError(true);
        }
    };
    var autocompleteTextChanged = function (e) {
        if (externalApiCall) {
            setOpen(false);
            setSearchText(e.target.value);
        }
        else {
            filterOptions(autoCompleteOptions, e.target.value);
        }
    };
    var renderGroupedOptions = function (groupedOptions) {
        return groupedOptions.map(function (grOptions, index) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Typography, { key: index.toString(), variant: linkTypographyVariant ? linkTypographyVariant : "subtitle1", style: groupLabelStyle }, grOptions.group),
                React.createElement("div", null, grOptions.children.map(function (option) {
                    return (React.createElement("div", { key: option.name },
                        React.createElement("div", { style: {
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: theme.spacing(2),
                                marginBottom: theme.spacing(2)
                            }, onClick: function (event) {
                                autoCompleteValueChanged(option);
                            } },
                            React.createElement(Link, { style: linkStyle }, option.name),
                            React.createElement(KeyboardArrowRightIcon, { style: { fontWeight: theme.typography.fontWeightBold }, color: "primary" })),
                        React.createElement("div", { style: { borderBottom: "1px inset" } })));
                }))));
        });
    };
    var renderLabel = function () {
        return (React.createElement(Typography, { variant: typographyVariant ? typographyVariant : "subtitle1", style: labelStyle }, label));
    };
    var renderAutocomplete = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(Autocomplete, { classes: {
                    popper: popperClassName ? popperClassName : ""
                }, style: autocompleteStyle, id: id ? id : "custom-autocomplete", open: open, onClose: function () {
                    setOpen(false);
                }, noOptionsText: noOptionsText ? noOptionsText : "No Options", disableClearable: disableClearable, forcePopupIcon: false, getOptionSelected: function (option, value) { return option.name === value.name; }, options: sortResult
                    ? autoCompleteOptions.sort(function (a, b) { return -b.groupBy.localeCompare(a.groupBy); })
                    : autoCompleteOptions, groupBy: function (option) { return (option.groupBy ? option.groupBy : ""); }, getOptionLabel: function (option) { return option.name; }, onChange: function (event, value) {
                    autoCompleteValueChanged(value);
                }, loading: false, renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { label: "", placeholder: fieldPlaceholder, variant: "outlined", className: inputClassName, onChange: autocompleteTextChanged, fullWidth: true, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (React.createElement(React.Fragment, null, loading ? (React.createElement(CircularProgress, { color: "primary", size: 20 })) : (React.createElement(SearchIcon, { style: searchIconStyle })))) }) }))); } })));
    };
    var renderNoOptionError = function () {
        return (React.createElement(Typography, { variant: typographyVariant ? typographyVariant : "subtitle1", color: "primary", style: {
                display: "flex",
                justifyContent: "center",
                fontSize: theme.typography.subtitle1.fontSize
            } }, noOptionsText));
    };
    var renderOptions = function () {
        if (groupedOptions && groupedOptions.length && !showNoOptionsError) {
            return renderGroupedOptions(groupedOptions);
        }
        else if (showNoOptionsError) {
            return renderNoOptionError();
        }
    };
    return (React.createElement(React.Fragment, null,
        label && renderLabel(),
        renderAutocomplete(),
        renderOptions()));
};

var useStyles$2 = makeStyles$1(function (theme) {
    return createStyles$1({
        cardContainer: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1],
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: "calc(45vw + 150px)"
        },
        posterCardContainer: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[1],
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        },
        fullCardContainer: {
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            width: "100vw"
        },
        gridContainer: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[2],
            height: "calc(25vw + 125px)",
            flex: "1 1 50vw",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        },
        mpSmallCardContainer: {
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[2],
            height: "calc(25vw + 90px)",
            flex: "1 1 50vw",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden"
        },
        imageContainer: {
            display: "flex",
            position: "relative",
            zIndex: 1,
            flex: "1 1 0%",
            boxSizing: "border-box"
        },
        defaultBody: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            boxSizing: "border-box",
            backgroundColor: theme.palette.background.default,
            borderBottomLeftRadius: theme.shape.borderRadius,
            borderBottomRightRadius: theme.shape.borderRadius
        },
        horizontalBody: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "150px",
            boxSizing: "border-box",
            backgroundColor: theme.palette.background.default
        },
        pushDownContainer: {
            alignSelf: "flex-end",
            width: "100%"
        },
        overlayTextContainer: {
            display: "none"
        },
        textContainer: {
            padding: "18px 5vw 0"
        },
        gridTextContainer: {
            padding: theme.spacing(3) + "px " + theme.spacing(3) + "px 0"
        },
        mpSmallCardTextContainer: {
            padding: theme.spacing(2) + "px " + theme.spacing(2.5) + "px 0"
        },
        fullTextContainer: {
            display: "flex",
            flexDirection: "column",
            margin: "16px 5vw 17px",
            boxSizing: "border-box"
        },
        titleTextAnimation: {
            animation: "$offerTitle 500ms ease-in-out"
        },
        "@keyframes offerTitle": {
            from: {
                transform: "translate(0px,-30px)",
                opacity: 0
            },
            to: {
                transform: "translate(0px,0px)",
                opacity: 1
            }
        },
        titleTextExitAnimation: {
            animation: "$offerTitleExit 600ms ease-in-out",
            opacity: 0
        },
        "@keyframes offerTitleExit": {
            from: {
                transform: "translate(0px,0px)",
                opacity: 1
            },
            to: {
                transform: "translate(0px,-30px)",
                opacity: 0
            }
        }
    });
});
var MPOfferCard = function (props) {
    var _a, _b, _c;
    var classes = useStyles$2();
    var imageDetails = props.imageDetails, mode = props.mode, title = props.title, subTitle = props.subTitle, isBlurred = props.isBlurred, orientation = props.orientation, logoDetails = props.logoDetails, showFavorites = props.showFavorites, style = props.style, isFavorite = props.isFavorite, onActionClicked = props.onActionClicked, onClick = props.onClick, uniqueId = props.uniqueId, actionElement = props.actionElement, badge = props.badge, options = props.options, informationStripDetails = props.informationStripDetails, animationProps = props.animationProps, rest = __rest(props, ["imageDetails", "mode", "title", "subTitle", "isBlurred", "orientation", "logoDetails", "showFavorites", "style", "isFavorite", "onActionClicked", "onClick", "uniqueId", "actionElement", "badge", "options", "informationStripDetails", "animationProps"]);
    var _d = useState({
        imageMode: "carousel",
        titleMode: "default",
        subTitleMode: "default",
        cardActionMode: "default"
    }); _d[0]; _d[1];
    var _e = useState({
        bodyHeight: "120px",
        containerClass: "gridContainer",
        textClass: "gridTextContainer"
    }); _e[0]; _e[1];
    var defaultBadgeStyle = {
        margin: "0",
        defaultBodyPaddingTop: "5px",
        top: "0",
        position: "absolute"
    };
    var OverriddenOfferImage = ((_a = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _a === void 0 ? void 0 : _a.OfferImage) || {};
    var ContentComponent = ((_b = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _b === void 0 ? void 0 : _b.ContentComponent) || undefined;
    var renderModeStyles = {
        full: {
            renderMode: {
                imageMode: "full",
                titleMode: "animated",
                subTitleMode: "animated",
                cardActionMode: "full"
            },
            modeStyles: {
                bodyHeight: "fit-content",
                containerClass: "fullCardContainer",
                textClass: "fullTextContainer"
            }
        },
        grid: {
            renderMode: {
                imageMode: "grid",
                titleMode: "grid",
                cardActionMode: "grid"
            },
            modeStyles: {
                bodyHeight: "120px",
                containerClass: "gridContainer",
                textClass: "gridTextContainer"
            }
        },
        poster: {
            renderMode: {
                imageMode: "poster",
                titleMode: "default",
                cardActionMode: "poster"
            },
            modeStyles: {
                bodyHeight: "",
                containerClass: "posterCardContainer",
                textClass: "overlayTextContainer"
            }
        },
        posterGrid: {
            renderMode: {
                imageMode: "posterGrid",
                titleMode: "grid",
                cardActionMode: "poster"
            },
            modeStyles: {
                bodyHeight: "",
                containerClass: "gridContainer",
                textClass: "overlayTextContainer"
            }
        },
        voucher: {
            renderMode: {
                imageMode: "voucher",
                titleMode: "default",
                cardActionMode: "voucher"
            },
            modeStyles: {
                bodyHeight: "150px",
                containerClass: "cardContainer",
                textClass: "textContainer"
            }
        },
        carousel: {
            renderMode: {
                imageMode: "carousel",
                titleMode: "default",
                cardActionMode: "default"
            },
            modeStyles: {
                bodyHeight: "150px",
                containerClass: "cardContainer",
                textClass: "textContainer"
            }
        },
        mpSmallCard: {
            renderMode: {
                imageMode: "mpSmallCard",
                titleMode: "mpSmallCard",
                cardActionMode: "mpSmallCard"
            },
            modeStyles: {
                bodyHeight: "65px",
                containerClass: "mpSmallCardContainer",
                textClass: "mpSmallCardTextContainer"
            }
        }
    };
    var getBadgeType = function () {
        if (badge && (badge === null || badge === void 0 ? void 0 : badge.badgeType)) {
            var badgeType = badge === null || badge === void 0 ? void 0 : badge.badgeType;
            console.log("badgeType", badgeType);
            var styles = badgeType === BadgeType[BadgeType.OVERLAYSTRIP]
                ? __assign(__assign({}, badgeStyle), { margin: "0", defaultBodyPaddingTop: "5px", top: "0px", position: "relative" }) : badgeType === BadgeType[BadgeType.MPDEFAULT]
                ? __assign(__assign({}, badgeStyle), { position: "absolute", top: -120.5, zIndex: 1 }) : __assign(__assign({}, badgeStyle), { margin: mode === "grid" ? "0px 12px" : "0px 5vw", defaultBodyPaddingTop: "5px", top: mode === "full" || mode === "carousel" ? "-16px" : "-10.5px", position: "absolute" });
            return styles;
        }
        else {
            return defaultBadgeStyle;
        }
    };
    var badgeStyle = getBadgeType();
    //styles for animation
    var defaultStyles = {
        marginTop: 120,
        opacity: 0,
        width: 0,
        marginLeft: 20
    };
    var enterStyles = {
        marginTop: spring(0),
        opacity: spring(1),
        width: spring(100),
        marginLeft: spring(0)
    };
    var leaveStyles = {
        marginTop: spring(60),
        opacity: spring(0),
        width: spring(100),
        marginLeft: spring(0)
    };
    ({
        marginTop: spring(0),
        opacity: spring(1)
    });
    ({
        marginTop: spring(-40),
        opacity: spring(0)
    });
    var titleAnimation = {
        defaultStyles: {
            marginTop: -40,
            opacity: 0
        },
        enterStyles: {
            marginTop: spring(0),
            opacity: spring(1)
        },
        exitStyles: {
            marginTop: spring(-40),
            opacity: spring(0)
        },
        units: {
            marginTop: "px",
            marginBottom: "px"
        }
    };
    var renderOfferImage = function () {
        var _a;
        var renderMode = renderModeStyles[mode].renderMode;
        return typeof ((_a = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _a === void 0 ? void 0 : _a.OfferImage) === "function" ? (React.createElement("div", { className: classes.imageContainer },
            React.createElement(OverriddenOfferImage, null))) : (React.createElement("div", { className: classes.imageContainer, style: {
                backgroundColor: isBlurred ? "#1E696969" : ""
            } },
            React.createElement(OfferImage, { mode: renderMode.imageMode, imageDetails: imageDetails, isBlurred: isBlurred, title: title, subTitle: subTitle, overlayIcon: options === null || options === void 0 ? void 0 : options.overlayIcon })));
    };
    var renderTitle = function () {
        var renderMode = renderModeStyles[mode].renderMode;
        return (React.createElement(TitleComponent, { title: title, mode: renderMode.titleMode }));
    };
    var renderSubtitle = function () {
        var renderMode = renderModeStyles[mode].renderMode;
        return (React.createElement(SubTitleComponent, { subTitle: subTitle || "", mode: renderMode.subTitleMode ? renderMode.subTitleMode : "default" }, "Offer SubTitle"));
    };
    var renderCardFooter = function () {
        var animate = (rest === null || rest === void 0 ? void 0 : rest.showAnimation) && !(rest === null || rest === void 0 ? void 0 : rest.showCarouselAnimation) && mode === "full";
        var showCarouselEnterAnimation = ((rest === null || rest === void 0 ? void 0 : rest.showCarouselAnimation) && (animationProps === null || animationProps === void 0 ? void 0 : animationProps.showEnterAnimation) &&
            classes.titleTextAnimation) ||
            "";
        var showCarouselExitAnimation = ((rest === null || rest === void 0 ? void 0 : rest.showCarouselAnimation) && (animationProps === null || animationProps === void 0 ? void 0 : animationProps.showExitAnimation) &&
            classes.titleTextExitAnimation) ||
            "";
        var _a = renderModeStyles[mode]; _a.renderMode; var modeStyles = _a.modeStyles;
        return (React.createElement("div", { className: classes.defaultBody, style: {
                height: modeStyles.bodyHeight
            } },
            React.createElement("div", { className: classes[modeStyles.textClass] + " " + showCarouselEnterAnimation + " " + showCarouselExitAnimation },
                animate ? (React.createElement(AnimationHelper, __assign({}, titleAnimation, (animationProps || { showEnterAnimation: false }), { enterAnimationDelay: 320, exitAnimationDelay: 100 }), renderTitle())) : (renderTitle()),
                subTitle && subTitle.length ? (animate ? (React.createElement(AnimationHelper, __assign({}, titleAnimation, (animationProps || { showEnterAnimation: false }), { enterAnimationDelay: 400, exitAnimationDelay: 100 }),
                    React.createElement(React.Fragment, null, renderSubtitle()))) : (renderSubtitle())) : (""))));
    };
    var renderHearIcon = function () {
        var _a = renderModeStyles[mode], renderMode = _a.renderMode; _a.modeStyles;
        return (React.createElement("div", null, mode !== "posterGrid" && mode !== "poster" && (React.createElement(CardAction, { logoDetails: logoDetails, mode: renderMode.cardActionMode, orientation: orientation, showFavorite: showFavorites, isFavorite: isFavorite, onActionClicked: function () {
                onActionClicked && onActionClicked(uniqueId ? uniqueId : "");
            }, actionElement: actionElement, options: options, showSavedAnimation: (rest === null || rest === void 0 ? void 0 : rest.showSavedAnimation) || false, showTitleTextAnimation: (rest === null || rest === void 0 ? void 0 : rest.showCarouselAnimation) && (animationProps === null || animationProps === void 0 ? void 0 : animationProps.showEnterAnimation) }))));
    };
    return (React.createElement("div", { className: classes[renderModeStyles[mode].modeStyles.containerClass], 
        // TODO compute this based on orientation
        style: style, onClick: function () {
            onClick && onClick(uniqueId ? uniqueId : "");
        } },
        React.createElement("div", null, renderHearIcon()),
        (rest === null || rest === void 0 ? void 0 : rest.showAnimation) &&
            !(rest === null || rest === void 0 ? void 0 : rest.showCarouselAnimation) &&
            mode === "full" ? (React.createElement(AnimationHelper, __assign({ enterStyles: enterStyles, exitStyles: leaveStyles, defaultStyles: defaultStyles, exitAnimationDelay: 240, units: {
                marginTop: "vw",
                marginLeft: "vw",
                width: "%"
            } }, (animationProps || { showEnterAnimation: false })), renderOfferImage())) : (renderOfferImage()),
        informationStripDetails ? (React.createElement(InformationStrip, { heading: informationStripDetails === null || informationStripDetails === void 0 ? void 0 : informationStripDetails.heading, content: informationStripDetails === null || informationStripDetails === void 0 ? void 0 : informationStripDetails.content })) : (""),
        ContentComponent &&
            typeof ((_c = options === null || options === void 0 ? void 0 : options.overrideComponent) === null || _c === void 0 ? void 0 : _c.ContentComponent) === "function" ? (React.createElement(ContentComponent, null)) : (""),
        React.createElement("div", { className: classes.pushDownContainer, style: {
                position: "relative"
            } },
            badge ? (React.createElement("div", { style: {
                    position: badgeStyle.position,
                    top: badgeStyle.top,
                    zIndex: 1,
                    margin: badgeStyle.margin,
                    width: "100%"
                } },
                React.createElement(Badge, { mode: mode, badgeType: badge === null || badge === void 0 ? void 0 : badge.badgeType, badgeText: badge === null || badge === void 0 ? void 0 : badge.badgeText, badgeStyle: badge === null || badge === void 0 ? void 0 : badge.badgeStyle, showCustomBadgeIcon: badge === null || badge === void 0 ? void 0 : badge.showCustomBadgeIcon, customBadgeIcon: badge === null || badge === void 0 ? void 0 : badge.customBadgeIcon }))) : (""),
            renderCardFooter())));
};

var useStyles$1 = makeStyles$1(function (theme) {
    return createStyles$1({
        root: {
            height: 18,
            width: 18,
            cursor: 'pointer',
            border: 0,
            background: 'none',
            padding: 0,
        },
        active: {
            backgroundColor: theme.palette.primary.main,
            height: 10,
            width: 10,
            borderRadius: 6,
            margin: 3
        },
        dot: {
            backgroundColor: '#b7cbe8',
            height: 10,
            width: 10,
            borderRadius: 6,
            margin: 3,
        }
    });
});
var TileDot = function (props) {
    var classes = useStyles$1();
    var active = props.active, onClick = props.onClick, index = props.index;
    var handleClick = function (event) {
        if (typeof onClick === "function") {
            onClick(event, index);
        }
    };
    return (React.createElement(Fragment, null,
        React.createElement("button", { type: "button", className: classes.root, onClick: handleClick },
            React.createElement("div", { className: active ? classes.active : classes.dot }))));
};

var useStyles = makeStyles$1(function (theme) {
    return createStyles$1({
        root: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center'
        }
    });
});
var Tiles = function (props) {
    var classes = useStyles();
    var dots = props.dots, index = props.index, onChangeIndex = props.onChangeIndex;
    var handleClick = function (event, index) {
        if (typeof onChangeIndex === "function")
            onChangeIndex(index);
    };
    var renderDots = function () {
        var children = [];
        for (var i = 0; i < dots; i += 1) {
            children.push(React.createElement(TileDot, { key: i, index: i, active: i === index, onClick: handleClick }));
        }
        return (React.createElement("div", { className: classes.root }, children));
    };
    return (React.createElement(Fragment, null, renderDots()));
};

var PopUp = function (props) {
    var theme = useTheme();
    var logoUrl = props.logoUrl, _a = props.merchantUrl, merchantUrl = _a === void 0 ? "" : _a, description = props.description, approvalText = props.approvalText, rejectionText = props.rejectionText, customStyle = props.customStyle, onClose = props.onClose;
    var _b = customStyle || {}, closeIconStyle = _b.closeIconStyle, logoStyle = _b.logoStyle, cardStyle = _b.cardStyle, overlayColor = _b.overlayColor, descriptionStyle = _b.descriptionStyle, approvalStyle = _b.approvalStyle, rejectionStyle = _b.rejectionStyle;
    return (React.createElement("div", { style: {
            position: "absolute",
            width: "100%",
            height: "100%",
            backgroundColor: overlayColor ? overlayColor : "rgba(11, 43, 88, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 100
        } },
        React.createElement("div", { style: cardStyle
                ? cardStyle
                : {
                    width: 355,
                    height: 370,
                    left: 10,
                    top: 149,
                    borderRadius: 25,
                    backgroundColor: theme.palette.primary.contrastText,
                    display: "flex",
                    flexDirection: "column"
                } },
            React.createElement("div", { style: { textAlign: "right", marginTop: 15, marginRight: 15 }, onClick: onClose },
                React.createElement("div", { style: { padding: "5px 6px 6px 5 px" } },
                    React.createElement(CloseIcon, { style: closeIconStyle
                            ? closeIconStyle
                            : {
                                color: "rgba(192, 192, 192)",
                                fontSize: 13
                            } }))),
            React.createElement("div", { style: { margin: "auto" } },
                React.createElement("a", { href: merchantUrl },
                    React.createElement("img", { src: logoUrl, alt: description, style: logoStyle
                            ? logoStyle
                            : {
                                maxWidth: 160,
                                maxHeight: 60,
                                marginTop: 12,
                                marginBottom: 55
                            } }))),
            React.createElement("div", { style: descriptionStyle
                    ? descriptionStyle
                    : {
                        maxWidth: 289,
                        maxHeight: 79,
                        fontSize: 16,
                        margin: "auto",
                        textAlign: "center",
                        color: "rgb(51, 51, 51)",
                        fontWeight: 600
                    } }, description),
            React.createElement("div", { style: approvalStyle
                    ? approvalStyle
                    : {
                        padding: "10px 23px 11px 24px",
                        borderRadius: 10,
                        margin: "auto",
                        color: theme.palette.primary.contrastText,
                        backgroundColor: "rgb(22, 81, 168)"
                    } }, approvalText),
            React.createElement("div", { style: rejectionStyle
                    ? rejectionStyle
                    : {
                        textAlign: "center",
                        marginTop: 22,
                        marginBottom: 23,
                        color: "rgb(22, 81, 168)"
                    } }, rejectionText))));
};

export { AnimationHelper, Badge, CountDownTimer, CustomAutocomplete, Filter, FooterContainer, FooterNavigation, Header, InformationStrip, Interest, MPOfferCard, OfferCard, PopUp, Svg, Tiles };
